import { FC, useMemo } from 'react';
import { useHookstate } from '@hookstate/core';
import { isMobile } from 'react-device-detect';
import { PromoAdPanel as PromoAdPanelComponent } from '../../components/PromoAdPanel';
import {
    current,
    account,
    meta,
    next,
    screenConfig as screenConfigState,
} from '../../stores/backend';
import { useAccount } from '../../hooks/use-account';

export const PromoAdPanel: FC = () => {
    const $account = useHookstate(account);
    const $meta = useHookstate(meta);
    const $next = useHookstate(next);
    const $current = useHookstate(current);
    const { language } = useHookstate(screenConfigState);
    const { wagered } = useAccount($next, $meta, $account);

    const countdownTimer = new Date($meta.timer.date.value);
    const {
        root_path = '',
        desktop = '',
        mobile = '',
        desktop_default = '',
        mobile_default = '',
    } = $current.value.promo_ad_image;

    const imageDefaultByOrientation = isMobile
        ? mobile_default
        : desktop_default;
    const imageByOrientiationInString = isMobile ? mobile : desktop;

    const mappedImages = useMemo(() => {
        const images = imageByOrientiationInString
            .split(',')
            .filter((imageItem) => imageItem !== '')
            .map((imageItem) => `${root_path}${imageItem.trim()}`);

        if (images.length > 0) {
            return images;
        }

        return [imageDefaultByOrientation];
    }, [imageByOrientiationInString, root_path, imageDefaultByOrientation]);

    return (
        <PromoAdPanelComponent
            promoAdImageUrlList={mappedImages}
            maxTickets={$next.game_cards_max.value}
            wagered={wagered}
            freeCards={$next.game_free_cards.value || 0}
            totalPromoCards={$next.game_total_promo_cards.value || 0}
            ticketsPurchased={
                Object.keys($next.player_cards.value || {}).length
            }
            countdownTimer={countdownTimer}
            currentLanguage={language.value}
        />
    );
};
